export default __webpack_public_path__ + "static/media/retiro_seclantas1.a46f9119.jpg";